import api from "../../utils/axios";
import { BULK_ORDER_OPERATIONS_ENDPOINTS } from "./endpoints";
import {
	AddOrderStatusHistoryRequest,
	OrderStatusHistoryOverview,
	ResponsibleUser,
} from "./types";

export const getOrderStatusHistory = async (
	orderId: number
): Promise<OrderStatusHistoryOverview> => {
	const response = await api.get<OrderStatusHistoryOverview>(
		BULK_ORDER_OPERATIONS_ENDPOINTS.orderHistory(orderId)
	);
	return response.data;
};

export const getResponsibleUsers = async (): Promise<ResponsibleUser[]> => {
	const response = await api.get<ResponsibleUser[]>(
		BULK_ORDER_OPERATIONS_ENDPOINTS.responsibleUsers
	);
	return response.data;
};

export const addOrderStatusHistory = async (
	body: AddOrderStatusHistoryRequest
): Promise<{ id: number }> => {
	const response = await api.post<{ id: number }>(
		BULK_ORDER_OPERATIONS_ENDPOINTS.addHistory,
		body
	);
	return response.data;
};

export const deleteOrderStatusHistory = async (
	historyId: number
): Promise<void> => {
	await api.delete(BULK_ORDER_OPERATIONS_ENDPOINTS.deleteHistory(historyId));
};
